import { useEffect } from "react";
import PromoPage from "./PromoPage";
import SearchBox from "../components/SearchBox";
import { QuerySuggestions } from "./components/QuerySuggestions";
import InstantSearchResults from "./InstantSearchResults";
import InstantSearch from "./InstantSearch";
import { useInstantSearch, useSearchBox } from "react-instantsearch";

function Redirect() {
  const { results } = useInstantSearch();

  useEffect(() => {
    if (!results) {
      console.log("[Algolia Redirect] No results object yet, skipping");
      return;
    }

    // Visual Editor redirects expose renderingContent.redirect.url
    const url = (results as any)?.renderingContent?.redirect?.url;

    if (!url || typeof window === "undefined") {
      return;
    }

    if (window.location.href !== url) {
      window.location.assign(url);
    } else {
      console.log("[Algolia Redirect] URL matches current location, not redirecting");
    }
  }, [results]);

  return null;
}

function TheContent() {
  const { query } = useSearchBox();

  return (
    <>
      {query ? (
        <InstantSearchResults />
      ) : (
        <PromoPage />
      )}
    </>
  );
}

export default function InstantSearchContent() {
  return (
    <InstantSearch>
      {/* Topbar to push down content */}
      <div className="tw-mt-searchHeight"></div>

      <div className="tw-gap-x-10 lg:tw-grid lg:tw-grid-cols-[280px,1fr] xl:tw-grid-cols-[minmax(max-content,280px)_1fr] tw-h-searchHeight tw-overflow-y-visible">
        {/* Left */}
        <div className="tw-min-w-[200px]">
          <SearchBox />
          <QuerySuggestions />
        </div>

        {/* Right */}
        <TheContent />
        <Redirect />
      </div>
    </InstantSearch>
  );
}